<template>
  <span>
          <dt>
            <p class="ml-2 text-sm font-medium text-gray-500 flex items-baseline">{{ item.name }}

             &nbsp;<InformationCircleIcon v-tooltip="{ content: item.info}" class="self-center flex-shrink-0 h-5 w-5"/>
            </p>
          </dt>

          <dd class="ml-2 pb-2 flex items-baseline sm:pb-2">
            <p class="text-xl font-semibold text-gray-900">
              {{ item.stat }}
            </p>
            <p :class="[item.changeType === 'increase' ? 'text-green-600' : 'text-red-600', 'ml-2 flex items-baseline text-sm font-semibold']">
              <ArrowSmUpIcon v-if="item.changeType === 'increase'" class="self-center flex-shrink-0 h-5 w-5 text-green-500" aria-hidden="true" />
              <ArrowSmDownIcon  v-if="item.changeType === 'decrease'" class="self-center flex-shrink-0 h-5 w-5 text-red-500" aria-hidden="true" />
              <span v-if="item.changeType !== null">{{ item.change }}</span>
            </p>
          </dd>
            </span>

</template>

<script>
import { ArrowSmDownIcon, ArrowSmUpIcon, InformationCircleIcon } from '@heroicons/vue/solid'


export default {
  components: {
    ArrowSmDownIcon,
    ArrowSmUpIcon,
    InformationCircleIcon,
  },
  props: {
    item: null,
  },
}
</script>
